import React, {useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import ToolBar from './ToolBar';
import {createJsScript} from './utils';

export const createLobbyBarScript = () =>
  createJsScript({
    scriptId: '#script-lobbybar',
    scriptUrl: `${window.NationalInstruments.measurementsLive.rootUrl}/measurementslive.js`,
    parentSelector: 'body',
  });

export const createWebSfpLoaderScript = () =>
  createJsScript({
    scriptId: '#websfp-loader',
    scriptUrl: `${
      process.env.INSTRUMENTS_ROOT_URL
        ? `${document.location.origin}${process.env.INSTRUMENTS_ROOT_URL}`
        : `${window.NationalInstruments.measurementsLive.rootUrl}/instruments`
    }/websfploader.js`,
    parentSelector: 'head',
  });

const LobbyBar = ({
  isPopoutMode,
  isSimulateMode,
  scriptLoaded,
  setScriptLoaded,
  setInstrumentsTabLoaded,
  setDeviceTabLoaded,
  instruments,
  isLargeScreen,
}) => {
  const toolbarRef = useRef();

  useEffect(() => {
    if (!isPopoutMode) {
      createLobbyBarScript().then(() => {
        window.NationalInstruments.measurementsLive.bentoBoxMode = true;
        setScriptLoaded(true);
      });
    } else {
      createWebSfpLoaderScript().then(() => {
        window.addEventListener('websfploaderLoaded', () => setScriptLoaded(true), {once: true});
      });
    }
  }, []);

  const params = new URLSearchParams(location.search);

  return (
    scriptLoaded && (
      <>
        {!isPopoutMode && (
          <>
            <measurements-live
              logo
              bentoboxmode
              simulatemode={isSimulateMode}
              deviceGroup="default"
              language={params.get('language') || 'en-us'}
              signaling-server-address={params.get('signaling-server-address') || 'server'}
              deviceid={params.get('id') || ''}
              usb-connection-address={params.get('usb-connection-address') || ''}
              on-device={window.NationalInstruments.measurementsLive.onDevice}
            />
          </>
        )}
        <ToolBar
          ref={toolbarRef}
          isPopoutMode={isPopoutMode}
          isSimulateMode={isSimulateMode}
          instruments={instruments}
          setInstrumentsTabLoaded={setInstrumentsTabLoaded}
          setDeviceTabLoaded={setDeviceTabLoaded}
          isLargeScreen={isLargeScreen}
        />
      </>
    )
  );
};

LobbyBar.propTypes = {
  isPopoutMode: PropTypes.bool.isRequired,
  scriptLoaded: PropTypes.bool.isRequired,
  setScriptLoaded: PropTypes.func.isRequired,
  setInstrumentsTabLoaded: PropTypes.func.isRequired,
  setDeviceTabLoaded: PropTypes.func.isRequired,
  instruments: PropTypes.object.isRequired,
  isLargeScreen: PropTypes.bool.isRequired,
};

export default LobbyBar;
